import { Injectable } from '@angular/core';

import { Status } from '@enums';
import { Document } from '@models';
import { HttpService } from '@services';
import { environment } from '../../../environment/environment';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  constructor(private http: HttpService) {}

  async setDocumentStatus(
    document: Document,
    status: Status
  ): Promise<Document> {
    const endpoint = `${environment.apiUrl}/document/status`;
    const response = await this.http.post<Document>(endpoint, {
      documentId: document.id,
      status,
    });

    if (!response.success) throw new Error(response.message);
    return response.data;
  }
}
